import React from 'react';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

// ICONS IMPORT
import options from '../../images/ui/options.svg';
//import clients from '../../images/ui/clients.svg';
import services from '../../images/ui/services.svg';
import slider from '../../images/ui/slider.svg';
import chip from '../../images/ui/chip.svg';
import blocks from '../../images/ui/blocks.svg';
import pages from '../../images/ui/pages.svg';
import projectLogo from '../../images/projectLogo.svg';
import CloseMorph from '../CloseMorph/CloseMorph';
import {
  Typography,
  IconButton,
  Toolbar,
  AppBar,
  Tooltip,
  Grid,
  Paper,
  Box,
  Divider,
  Button,
} from '@mui/material';
import { Settings, ExitToApp, OpenInNew } from '@mui/icons-material';
import { useAuth } from '../../hooks/useAuth';
import { OpalCard, paperStyles } from '../OpalCard/OpalCard';

const menuItems = [
  { label: 'dashboard', link: '/site-dash', image: options },
  { label: 'pages', link: '/pages', image: pages },
  { label: 'projects', link: '/projects', image: services },
  { label: 'slider', link: '/sliders', image: slider },
  { label: 'blocks', link: '/blocks', image: blocks },
  { label: 'files', files: '/files', image: chip }
];

const Item = styled(Paper)(({ theme, open }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  fontWeight: 'bold',
  maxWidth: '150px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  transitionProperty: 'all',
  transitionDuration: '1.5s',
  transitionDelay: '0.25s',
  cursor: 'pointer'
}));

const UserControlLinks = ({ navigate }) => {
  const { logout } = useAuth();

  return (
    <Grid container sx={{ position: 'absolute', bottom: 0 }}>
      <Grid item xs={12} sm={12}>
        <Box
          sx={{
            display: 'inline-flex',
            width: '100%',
            alignItems: 'center',
            borderColor: 'divider',
            bgcolor: 'primary.main',
            color: 'primary.dark',
            justifyContent: 'space-around',
            '& svg': {
              m: 1,
            },
          }}
        >
          <Tooltip title="View Site" placement="top">
            <Button aria-label="view site" variant="secondary" onClick={() => window.location.assign('https://mm-h.co.uk')}>
              <OpenInNew />
            </Button>
          </Tooltip>
          <Divider orientation="vertical" variant="middle" flexItem />
          <Tooltip title="Site settings" placement="top">
            <Button aria-label="view site" variant="secondary" onClick={() => navigate('/site-settings')}>
              <Settings />
            </Button>
          </Tooltip>
          <Divider orientation="vertical" variant="middle" flexItem />
          <Tooltip title="Log out" placement="top">
            <Button onClick={logout} variant="secondary" aria-label="view site">
              <ExitToApp />
            </Button>
          </Tooltip>
        </Box>
      </Grid>
    </Grid>
  );
};

const DrawerContent = ({ setOpen, open }) => {
  const navigate = useNavigate();

  return (
    <>
      <AppBar position="sticky" color="default">
        <Toolbar>
          <IconButton
            fontSize="small"
            color="default"
            aria-label="Open 
            drawer"
            onClick={() => setOpen(false)}
            style={{ marginLeft: -12, marginRight: 20 }}
          >
            <CloseMorph open={open} />
          </IconButton>
          <Typography variant="h6" color="primary" noWrap style={{ flexGrow: 1 }}>
            Site options
          </Typography>
        </Toolbar>
      </AppBar>

      <Grid container spacing={3} sx={{ padding: '2rem', maxWidth: '320px' }}>
        <Grid item xs={12} sx={{ padding: '2rem', maxWidth: '320px' }}>
          <img className="user-image" src={projectLogo} width="240" alt="project logo" />
        </Grid>
        {menuItems.map((i, n) => (
          <Grid item xs={6} sm={6} key={n}>
            <OpalCard>
              <Item sx={{ ...paperStyles }} open={open} elevation={0} onClick={() => { setOpen(false); navigate(i.link); }}>
                <img src={i.image} alt={`${i.label}-icon`} />
                <Typography variant="button">{i.label.toUpperCase()}</Typography>
              </Item>
            </OpalCard>
          </Grid>
        ))}
      </Grid>
      <UserControlLinks navigate={navigate} />
    </>
  );
};

export default DrawerContent;
